import { render, staticRenderFns } from "./TypeLike.vue?vue&type=template&id=7930672d&scoped=true"
import script from "./TypeLike.vue?vue&type=script&lang=js"
export * from "./TypeLike.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7930672d",
  null
  
)

export default component.exports